var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderCompletedIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "222px",
    height: "92px",
    viewBox: "0 0 222 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/paper plane") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop/user/1440+/checkout-4",
    transform: "translate(-682.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/login/confirmed",
    transform: "translate(678.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(201.620816, 61.149487) rotate(-282.000000) translate(-201.620816, -61.149487) translate(178.620816, 37.649487)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    transform: "translate(3.911227, 36.944987) rotate(-7.000000) translate(-3.911227, -36.944987) ",
    cx: 3.91122703,
    cy: 36.9449875,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    transform: "translate(34.906305, 43.214369) rotate(-7.000000) translate(-34.906305, -43.214369) ",
    cx: 34.906305,
    cy: 43.2143687,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    transform: "translate(26.061347, 4.000000) rotate(-7.000000) translate(-26.061347, -4.000000) ",
    cx: 26.0613467,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9388421,33.7215619 L27.9388421,29.7215619",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(25.938842, 31.721562) rotate(-37.000000) translate(-25.938842, -31.721562) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9388421,33.7215619 L27.9388421,29.7215619",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(25.938842, 31.721562) rotate(-37.000000) translate(-25.938842, -31.721562) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9388421,33.7215619 L27.9388421,29.7215619",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(25.938842, 31.721562) scale(-1, 1) rotate(37.000000) translate(-25.938842, -31.721562) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D2D2D2",
    transform: "translate(14.742548, 18.487401) rotate(-7.000000) translate(-14.742548, -18.487401) ",
    cx: 14.7425482,
    cy: 18.4874014,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-16",
    fill: "#D2D2D2",
    transform: "translate(43.752534, 25.000521) rotate(-7.000000) translate(-43.752534, -25.000521) ",
    cx: 43.7525338,
    cy: 25.0005213,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9814408,16.3932611 C30.3147741,16.3932611 34.9814408,18.3932611 38.9814408,22.3932611",
    id: "Path-7",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(31.981441, 19.393261) rotate(-7.000000) translate(-31.981441, -19.393261) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(42.557208, 65.564662) rotate(-83.000000) translate(-42.557208, -65.564662) translate(17.057208, 26.064662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    transform: "translate(46.450266, 33.401871) scale(-1, -1) rotate(-24.000000) translate(-46.450266, -33.401871) ",
    cx: 46.4502662,
    cy: 33.4018707,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    transform: "translate(4.000000, 39.874275) scale(-1, -1) rotate(-24.000000) translate(-4.000000, -39.874275) ",
    cx: 4,
    cy: 39.8742746,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    transform: "translate(23.923648, 74.789146) scale(-1, -1) rotate(-24.000000) translate(-23.923648, -74.789146) ",
    cx: 23.9236476,
    cy: 74.7891463,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2438707,33.1954752 L34.2438707,29.1954752",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(32.243871, 31.195475) scale(-1, -1) rotate(-54.000000) translate(-32.243871, -31.195475) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2438707,33.1954752 L34.2438707,29.1954752",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(32.243871, 31.195475) scale(-1, -1) rotate(-54.000000) translate(-32.243871, -31.195475) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2438707,33.1954752 L34.2438707,29.1954752",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(32.243871, 31.195475) scale(1, -1) rotate(54.000000) translate(-32.243871, -31.195475) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.125933, 53.354278) scale(-1, 1) rotate(-138.000000) translate(-17.125933, -53.354278) translate(5.125933, 47.354278)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-16",
    fill: "#D2D2D2",
    transform: "translate(3.000000, 4.000000) scale(-1, -1) rotate(-24.000000) translate(-3.000000, -4.000000) ",
    cx: 3,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89615654,2.92071513 C14.2294899,2.92071513 18.8961565,4.92071513 22.8961565,8.92071513",
    id: "Path-7",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(15.896157, 5.920715) scale(-1, -1) rotate(-24.000000) translate(-15.896157, -5.920715) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.2188595,15.5622568 L28.2188595,11.5622568",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(26.218860, 13.562257) scale(-1, -1) rotate(-54.000000) translate(-26.218860, -13.562257) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2188595,15.5622568 L28.2188595,11.5622568",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(26.218860, 13.562257) scale(-1, -1) rotate(-54.000000) translate(-26.218860, -13.562257) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2188595,15.5622568 L28.2188595,11.5622568",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(26.218860, 13.562257) scale(1, -1) rotate(54.000000) translate(-26.218860, -13.562257) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D2D2D2",
    transform: "translate(30.512162, 57.625479) scale(-1, -1) rotate(-24.000000) translate(-30.512162, -57.625479) ",
    cx: 30.5121621,
    cy: 57.625479,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    fill: "#D2D2D2",
    transform: "translate(30.273330, 3.000000) scale(-1, -1) rotate(-24.000000) translate(-30.273330, -3.000000) ",
    cx: 30.2733301,
    cy: 3,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/paper-plane",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(68.000000, 6.000000)",
    stroke: "#4CCFEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "37.3766437 57.2395162 0 53.847735 104 0 99.4079058 80 54.0357701 64.333016"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "104 0 37.0574713 57.3867596 47.8643369 90 53.8681511 64.2857143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.816092,90 L63.3563218,68.75",
    id: "Stroke-5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M198.397525,35.1884344 L202.397525,31.1884344",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(200.397525, 33.188434) rotate(-37.000000) translate(-200.397525, -33.188434) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.397525,35.1884344 L202.397525,31.1884344",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(200.397525, 33.188434) rotate(-37.000000) translate(-200.397525, -33.188434) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.397525,35.1884344 L202.397525,31.1884344",
    id: "Path-6",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(200.397525, 33.188434) scale(-1, 1) rotate(37.000000) translate(-200.397525, -33.188434) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    fill: "#D2D2D2",
    fillRule: "evenodd",
    transform: "translate(190.228831, 28.228831) rotate(-7.000000) translate(-190.228831, -28.228831) ",
    cx: 190.228831,
    cy: 28.228831,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCompletedIllustration);
export default __webpack_public_path__ + "static/media/order-completed-illustration.4a2244a82116a6da1eadc8076cdc80d4.svg";
export { ForwardRef as ReactComponent };